import { render, staticRenderFns } from "./StartForm9.vue?vue&type=template&id=b48a734a&scoped=true"
import script from "./StartForm9.vue?vue&type=script&lang=ts"
export * from "./StartForm9.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48a734a",
  null
  
)

export default component.exports